import React from "react";

import "./NewsHeader.scss";

const NewsHeader = () => {
  return <p className="news-header">NEWS</p>;
};

export default NewsHeader;
